<template>
  <div class="ui-input">
    <div class="ui-input-container">
      <div class="title">{{$t(title)}}</div>
      <div class="icons-left" v-if="$slots.left"><slot name="left"></slot></div>
     
     <!-- input working with :value and @input-="" instead of v-model otherwise android is not updating as we type-->
     <input class="input" :class="{'read-only':readonly, 'no-padding-left':$slots.left}" :autocapitalize="autocapitalize" :accept="accept" :type="type" :value="model" @input="model = $event.target.value" :readonly="readonly">
      <div class="icons-right" v-if="$slots.icons"><slot name="icons"></slot></div>
    </div>
    <div class="after" v-if="$slots.after"><slot name="after"></slot></div>
  </div>
  
</template>

<script>

export default {
  name: 'ui-input',
  props:{
    val: {type: String, default:""},
    type:{default:"text"},
    autocapitalize:{default:"on"},
    title:{default:""},
    readonly:{default:false},
    accept:{default:"*"},
  },
  methods:{
    focus(e){
      
        e.preventDefault(); e.stopPropagation();
        window.scrollTo(0,100); //the second 0 marks the Y scroll pos. Setting this to i.e. 100 will push the screen up by 100px. 
        
    }
  },
  mounted(){
    
  },
  data:function(){
    return {
      on:false,
      inputValue:"",
      updateTime:0,
    }
  },
  computed:{
    model:{
      get(){
        return this.val
      },
      set(v){
        this.$emit('input', v);
      }
    }
   
  }
 
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icons-right{
  display:flex;
  align-items: center;
  margin-right:5px;
}
.icons-left{
  display:flex;
  align-items: center;
  margin-left:8px;
}
.ui-input{
  display:flex;
  margin-bottom:15px;
  align-items: center;
}
.ui-input-container{
  position:relative;
  border:1px solid #707070;
  border-radius:4px;
  display:flex;
  flex:1;
}
.after{
  padding:0 5px;
}
.title{
  padding:0 5px;
  position:absolute;
  font-size:.7em;
  display:inline-block;
  background-color:#FFFFFF;
  top: -8px;
  left: 5px;
}

input{
  border:none;
  width:100%;
  outline: none;
  font-size:1.0em;
  padding:8px 10px;
  background-color:transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
}
input:after{
  content:"\00a0";
}
.no-padding-left{
  padding-left:0px;
}

.read-only{
  color:#707070;
}
</style>
